import React, { useContext } from 'react';
import { SuiteHeaderContext } from '../SuiteHeaderProvider';

export const AppLauncher: React.FC = () => {
  const { localizationMap } = useContext(SuiteHeaderContext);
  const { waffleNotAvailableDescription } = localizationMap;
  return (
    <div>
      <h4>{waffleNotAvailableDescription}</h4>
    </div>
  );
};
